import Chart from 'chart.js/dist/chart';

const reviewsChart = document.querySelectorAll(".i-review-chart");
reviewsChart.forEach(chart => {

  let reviewData = chart.querySelector('.i-review-chart__percent').textContent;
  reviewData = [parseInt(reviewData.slice(0, -1)), 100 - parseInt(reviewData)]

  const canvas = chart.querySelector(".i-review-chart__canvas");
  const canvasAssistant = chart.querySelector(".i-review-chart__canvas-assistant");

  let bgColor
  let wight

  if (window.innerWidth > 1199) {
    wight = 65
  } else {
    if (window.innerWidth > 575) {
      wight = 51
    } else {
      wight = 36
    }
  }

  if (chart.classList.contains("--positive")) {
    bgColor = "#79C431";
  } else {

    if (chart.classList.contains("--neutral")) {
      bgColor = "#F5AC21";
    } else {
      bgColor = "#FD3E3E";
    }
  }

  const data = {
    datasets: [{
      data: reviewData,
      backgroundColor: [
        bgColor,
        "transparent"
      ],
      hoverBackgroundColor: [
        bgColor,
        "transparent"
      ],
      hoverOffset: 0,
      borderWidth: 0,
      borderRadius: 15,
      cutout: wight,
    }],
  };

  const config = {
    type: 'pie',
    data: data,
    options: {
      responsive: true,
      mantainAspectRatio: false,
      dynamicDisplay: true,
      animation: {
        duration: 1000,
      },
      plugins: {
        legend: {
          display: false
        }
      },
    }
  };

  const dataAssistant = {
    datasets: [{
      data: "100%",
      backgroundColor: "#d1e3f2",
      hoverBackgroundColor: "#d1e3f2",
      hoverOffset: 0,
      borderWidth: 0,
      borderRadius: 0,
      cutout: wight,
    }],
  };
  const configAssistant = {
    type: 'pie',
    data: dataAssistant,
    options: {
      responsive: true,
      mantainAspectRatio: false,
      dynamicDisplay: true,
      animation: {
        duration: 0
      },
      plugins: {
        legend: {
          display: false
        }
      },
    }
  };

  const chartAssistant = new Chart(canvasAssistant, configAssistant);
  const graph = new Chart(canvas, config);

  window.addEventListener("resize", function () {

    let wight

    if (window.innerWidth > 1199) {
      wight = 65
    } else {
      if (window.innerWidth > 575) {
        wight = 51
      } else {
        wight = 36
      }
    }
    config.options.animation.duration = 0;
    dataAssistant.datasets[0].cutout = wight;
    data.datasets[0].cutout = wight;

    chartAssistant.update()
    graph.update()
  });
});
